import { IconBase, IconProps, IconWeight } from '@phosphor-icons/react';
import { forwardRef, ReactElement } from 'react';

import { IconType } from './IconTypes';

const circles = [];
const positions = ['42.5', '128', '213.5'];
const times = ['0', '1', '7', '3', '6', '5', '8', '4', '2'];

for (let i = 0; i < 3; i++) {
  for (let j = 0; j < 3; j++) {
    circles.push(
      <circle
        key={`${positions[i]}-${positions[j]}`}
        cx={positions[i]}
        cy={positions[j]}
        r="30.476"
      >
        <animate
          attributeName="fillOpacity"
          begin={`${times.pop()}00ms`}
          calcMode="linear"
          dur="1s"
          repeatCount="indefinite"
          values="1;.2;1"
        />
      </circle>,
    );
  }
}

const Icon: IconType = ({ color, strokeWidth }) => (
  <g stroke={color} strokeWidth={strokeWidth}>
    {circles}
  </g>
);

const buildWeights = (color: string) =>
  new Map<IconWeight, ReactElement>([
    ['bold', <Icon color={color} strokeWidth={24} />],
    ['duotone', <Icon color={color} strokeWidth={16} />],
    ['fill', <Icon color={color} strokeWidth={0} />],
    ['light', <Icon color={color} strokeWidth={12} />],
    ['thin', <Icon color={color} strokeWidth={8} />],
    ['regular', <Icon color={color} strokeWidth={16} />],
  ]);

export const Grid = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <IconBase
    ref={ref}
    {...props}
    weights={buildWeights(props.color ?? 'currentColor')}
  />
));

Grid.displayName = 'Grid';
